import {blockContentTemplate, blockTemplate} from './block';
import {paragraphTemplate} from './paragraph';
import {titleTemplate} from './title';

export const verticalBlockTemplate = {
  '_template': 'vertical',
  ...blockTemplate,
  content: {
    ...blockContentTemplate,
    blocks: [
      titleTemplate,
      paragraphTemplate
    ]
  }
};
const data = {
  '_template': 'vertical',
  'background': {
    'color': {
      'xl': '#edecf6'
    },
    'backgroundColor': {
      'xl': '#FBFBFB'
    }
  },
  'text': {
    'align': {
      'xl': 'left'
    }
  },
  'box': {
    'padding': {
      'paddingTop': {
        'xl': 100,
        'xs': 35
      },
      'paddingLeft': {
        'xl': 20,
        'xs': 5
      },
      'paddingRight': {
        'xl': 20,
        'xs': 5
      },
      'paddingBottom': {
        'xl': 100,
        'xs': 35
      }
    }
  },
  'content': {
    'box': {
      'size': {
        'maxWidth': {
          'xl': '1445'
        }
      },
      'padding': {
        'paddingTop': {
          'xs': 10
        },
        'paddingBottom': {
          'xs': 10
        },
        'paddingLeft': {
          'xs': 12
        },
        'paddingRight': {
          'xs': 12
        }
      }
    },
    'blocks': [
      {
        '_template': 'title',
        'title': {
          'es': 'This Week Highlights',
          'en': 'Aliquam quaerat voluptatem'
        },
        'text': {
          'fontSize': {
            'xl': 48,
            'xs': 36
          },
          'align': {
            'xl': 'center'
          },
          'bold': {
            'xl': 'bold'
          },
          'lineHeight': {
            'xl': 1.2,
            'xs': 1.2
          }
        },
        'box': {
          'size': {
            'maxWidth': {
              'xl': 800
            }
          }
        }
      },
      {
        '_template': 'title',
        'title': {
          'es': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.',
          'en': 'Aliquam quaerat voluptatem'
        },
        'level': '3',
        'text': {
          'fontSize': {
            'xl': 16
          },
          'bold': {
            'xl': 'medium'
          },
          'textColor': {
            'xl': '#737373'
          },
          'align': {
            'xl': 'center'
          }
        },
        'box': {
          'size': {
            'maxWidth': {
              'xl': 580
            }
          },
          'margin': {
            'marginTop': {
              'xl': 20,
              'xs': 10
            }
          }
        }
      }
    ],
    'text': {
      'align': {
        'xl': 'center'
      }
    }
  },
  '_id': 'BK1631031792244'
};
